// Third party
import React, { Component } from 'react';

// Components
import { withErrorBoundary } from '../errors';
import AdvancedSearchInput from './AdvancedSearchInput';

// Utils
import { populateFundFilters } from '../../../utils/advanced-search';
import { formatMessage } from '../../../utils/i18n';
import SearchOptions from '@/types/search-options';
import User from '@/types/user';
import FundFiltersData from '@/types/fund-filters-data';
import FilterType from '@/types/filter-type';

interface Props {
  onFundSearch: (options: SearchOptions) => void;
  clearPreLoadQuery: (query: string) => void;
  filtersData: FundFiltersData;
  hasData?: boolean;
  loadingFilters?: boolean;
  preLoadQuery?: string;
  minimizedFiltersToShow?: number;
  loadingResults?: boolean;
  user: User;
}

class FundSearchInput extends Component<Props> {
  getFilters = (): FilterType[] => populateFundFilters(this.props.filtersData, this.props.user);

  render() {
    const { loadingFilters, hasData, preLoadQuery, minimizedFiltersToShow, loadingResults } = this.props;
    const loadingProps = { loadingFilters, loadingResults };

    return (
      <AdvancedSearchInput
        {...loadingProps}
        className="fund-search-input"
        filters={this.getFilters()}
        placeholder="Search.Funds.Placeholder"
        buttonLabel="Search.Funds.Apply"
        onSearch={this.props.onFundSearch}
        clearPreLoadQuery={this.props.clearPreLoadQuery}
        preLoadQuery={preLoadQuery}
        placeholderText={formatMessage('Search.Funds.Placeholder')}
        applySearchText={formatMessage(`Search.${loadingResults ? 'Searching' : 'Funds.Apply'}`)}
        minimizedFiltersToShow={minimizedFiltersToShow}
        hasData={hasData}
      />
    );
  }
}

export default withErrorBoundary(FundSearchInput);
